const BASE_URL = "https://service-marketplace-t5fy.onrender.com";
export default BASE_URL;